<template>
  <div class="summary-card-body-item">
    <div class="summary-card-body-item__value">
      <slot>
        <strong>{{ value }}</strong><span>{{ subValue }}</span>
      </slot>
    </div>
    <span class="summary-card-body-item__title">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'SummaryCardBodyItem',
  props: {
    value: {
      type: [Number, String],
      required: false,
      default: 0
    },
    subValue: {
      type: [Number, String],
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
  },
  data: () => ({
  }),
  methods: {
  },
}
</script>

<style lang="scss">
.summary-card-body-item {
  &__value {
    font-size: 12px;
    line-height: 18px;

    strong {
      font-size: 20px;
      line-height: 32px;
      font-weight: 600;
    }

    span {
      margin-left: 8px;
    }

    span + strong {
      margin-left: 12px;
    }
  }
  &__title {
    font-size: 12px;
    line-height: 18px;;
  }
}
</style>
